module.exports = __webpack_public_path__ + "static/media/step-name.ae7ad9e5.png";